export function getDayEnd(dateString: string = new Date().toISOString()): string {
  const date = new Date(dateString);
  date.setHours(23, 59, 59, 999);
  return date.toISOString();
}
